import { applicationModuleRegistry } from '@philips-internal/oswald-ui-foundation';
import { ApplicationRoute } from '../../constants/routes';

export function setupElectronicMedicationAdministration(): void {
  applicationModuleRegistry.register({
    entry: 'ADEP#9129',
    id: 'ADEP#9129',
    name: 'module.electronic-medication-administration',
    route: ApplicationRoute.ELECTRONIC_MEDICATION_ADMINISTRATION,
    routes: [
      {
        main: true,
        name: 'function.search-patient-emar',
        route: ApplicationRoute.SEACH_PATIENT_EMAR,
      }
    ]
  });
}
